import { useCallback } from "react";
import { useVoiceControl, VoiceButton } from "../voice/VoiceProvider";
import { heardAny } from "../voice/match";
import { useContent, useT } from "../i18n/LocaleProvider";

interface Props {
  onHome: () => void;
}


export function TermsPage({ onHome }: Props) {
  const t = useT();
  const { termsPoints } = useContent();
  const onCommand = useCallback(
    (transcript: string): boolean => {
      if (heardAny(transcript, [...t.commands.home, ...t.commands.back])) {
        onHome();
        return true;
      }
      return false;
    },
    [onHome, t],
  );
  useVoiceControl(onCommand);

  return (
    <div className="facts-page">
      <header className="player-header">
        <button className="home-btn" onClick={onHome} aria-label={t.backToHome}>
          {t.home}
        </button>
        <h1>{t.termsTitle}</h1>
      </header>

      <p className="subtitle">{t.termsSubtitle}</p>

      <div className="control-bar">
        <VoiceButton />
      </div>

      <div className="facts-grid">
        {termsPoints.map((p, i) => (
          <div className="fact-card" key={i}>
            <div className="fact-emoji" aria-hidden="true">
              {p.emoji}
            </div>
            <p className="fact-text">{p.text}</p>
          </div>
        ))}
      </div>

      <div className="info-note">
        <p>
          <b>{t.forGrownUpsLead}</b> {t.termsGrownUps}
        </p>
      </div>
    </div>
  );
}
